/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal';
import Teacher from 'entities/Teacher';
import UserActions from 'user/UserActions';

class ReportTeacherSelectModal extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    teacher: PropTypes.instanceOf(Teacher).isRequired,
    onRequestHide: PropTypes.func,
  };

  reportTeacher = (key: string, notes: string) => {
    UserActions.reportUser(this.props.teacher.getUuid(), key, notes);
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  render() {
    const options = ['This person doesn’t teach at this school', 'Inappropriate behavior'];
    return (
      <ReportToRemindSelectModal
        {...this.props}
        options={options}
        reportee={this.props.teacher.getName()}
        notesPlaceholder="Why are you reporting this Teacher?"
        onReport={this.reportTeacher}
      />
    );
  }
}
export default ReportTeacherSelectModal;
